exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transparent-list-well{margin:0 auto;margin-left:0;width:100%;height:100%;max-width:420px}.transparent-list-header-text{font-weight:700;text-align:center}.transparent-list-word-table-header{height:36px}.transparent-list-word-table-body{height:calc(100% - 36px);overflow-x:hidden;overflow-y:auto}.transparent-list-table{display:flex;flex-direction:column}.transparent-list-table-row{display:flex;flex-direction:row}.transparent-list-table-column{margin:2px 5px;border-radius:10px;width:150px;padding:5px;background-color:hsla(0,0%,93%,.3);text-align:center;pointer-events:none}.transparent-list-table-column.clickable{pointer-events:auto;color:#5caaee;cursor:pointer}.transparent-list-table-column.clickable:hover{color:#337ab7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--3-1!../node_modules/postcss-loader/lib!../node_modules/sass-loader/lib/loader.js!./assets/scss/TransparentWordList.scss
// module id = 710
// module chunks = 0